import React, {Fragment} from 'react';

import {Box, Stack, Typography} from '@mui/material';
import {TypeLocalNameEnum} from 'domain/usecases';
import {Drawer} from 'presentation/components/Drawer';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {DistanceSlider} from '../../../DistanceSlider';
import {DistanceFilterContentProps} from './types';

const {
	referencePoint,
	cityReference,
	neighborhoodReference,
	maxDistance,
	referencePointMaxDistance,
	changeLocation,
	fromYourLocation,
} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function DistanceFilterContent({
	distanceFilterAtMaxDistance,
	openDrawerState,
}: DistanceFilterContentProps) {
	const bookingData = useBookingStore(state => state.bookingData);
	const {typeLocalName, cityName, reference} = bookingData;

	const isCity = typeLocalName === TypeLocalNameEnum.CIDADE;
	const isGeoloc = typeLocalName === TypeLocalNameEnum.COORDENADAS;
	const locationLabel = isCity ? cityReference : neighborhoodReference;
	const formattedLocation = isCity ? cityName : reference;

	const distanceFilterTitle = (
		<Fragment>
			{distanceFilterAtMaxDistance ? referencePointMaxDistance : referencePoint}{' '}
			{isGeoloc ? '' : locationLabel}{' '}
			<Typography color="primary.dark" component="span" fontWeight={700}>
				{isGeoloc ? fromYourLocation : formatText(formattedLocation)}
			</Typography>
			. {distanceFilterAtMaxDistance ? changeLocation : ''}
		</Fragment>
	);

	return (
		<Drawer.Content>
			<Stack gap={1}>
				<Stack>
					<Typography variant="subtitle1" fontWeight={700} color="text.secondary">
						{maxDistance}
					</Typography>
					<Typography variant="body2" color="text.secondary">
						{distanceFilterTitle}
					</Typography>
				</Stack>
				<Box px={1}>
					<DistanceSlider drawerIsOpen={openDrawerState} />
				</Box>
			</Stack>
		</Drawer.Content>
	);
}
